// Szolgáltatás-hozzárendelések feature — query-kulcs gyár + a lista-szűrő típusa. A tényleges hívásokat a
// route/komponens a tipizált ts-rest kliensen (`api.serviceAssignments.*`) intézi; a kulcsok itt élnek
// (cache-egységesítés). A `@atlas/contracts` a szerződés forrás-igazsága — itt csak kulcs-logika van.

/** A lista-lekérdezés szűrői (a query-kulcs része — szűrő-/rendezés-váltás új cache-bejegyzést nyit).
 *  A `sort` a rendezés-KULCS (serviceName | clientName | netAmount | status), az `order` az irány; a `q`,
 *  `clientId`, `accountId`, `type`, `status`, `billingFrequency` a toolbar-szűrők. */
export interface ServiceAssignmentListFilters {
  q: string;
  clientId: string;
  accountId: string;
  type: string;
  status: string;
  billingFrequency: string;
  sort: string;
  order: 'asc' | 'desc';
}

/** Query-kulcs gyár — a lista/detail/refs cache egységes címzése (invalidálás + a szerkesztő). */
export const serviceAssignmentKeys = {
  all: ['service-assignments'] as const,
  lists: () => ['service-assignments', 'list'] as const,
  list: (filters: ServiceAssignmentListFilters) =>
    ['service-assignments', 'list', filters] as const,
  detail: (id: string) => ['service-assignments', 'detail', id] as const,
  /** A form forrásai (katalógus szolgáltatás/plan/ár + ügyfelek + fiókok). */
  /** A form forrásai. A `lang` a kulcs RÉSZE: a személy-nevek sorrendje nyelvfüggő, tehát nyelvváltáskor
   *  ÚJ lekérés kell — különben a magyar sorrendű nevek maradnának az angol felületen (a supportTeamRefs mintája). */
  refs: (lang: string) => ['service-assignments', 'refs', lang] as const,
  /** A lista-oldal FIGYELEM-panelje (hamarosan induló, függő hozzárendelések). */
  attention: () => ['service-assignments', 'attention'] as const,
};
